module.exports = __webpack_public_path__ + "img/blank-dpd.b64c5ac0.jpg";